import { daysOfWeek } from "@/app/fees/fees";
import { t } from "i18next";
import { FC, Fragment, useEffect, useState } from "react";

export type CheckBoxDaysprops = {
  onChange: (days: string[]) => void;
  value: string[];
  error?: boolean;
  disabled?: boolean;
};

export const CheckBoxDays: FC<any> = ({
  value = [],
  onChange,
  error,
  disabled,
}) => {
  const handleDayChange = (dayName: string, checked: boolean) => {
    let newSelected;
    if (checked) {
      newSelected = [...value, dayName];
    } else {
      newSelected = value.filter((_day: string) => _day !== dayName);
    }

    if (typeof onChange === "function") {
      onChange(newSelected);
    }
  };

  return (
    <Fragment>
      <div className="flex justify-center flex-col gap-2">
        <div className="flex space-x-1">
          {daysOfWeek.map((day, index) => (
            <label
              key={day.id}
              className={`cursor-pointer ${
                disabled ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              <input
                type="checkbox"
                className="hidden peer"
                id={`day-${index}`}
                checked={value.includes(day.name)}
                disabled={disabled}
                onChange={(event) => {
                  handleDayChange(day.name, event.target.checked);
                }}
              />
              <span className="px-2 py-1 border rounded-full text-gray-500 text-sm border-gray-300 peer-checked:bg-primary-500 peer-checked:border-primary-500 peer-checked:text-white">
                {day.text}
              </span>
            </label>
          ))}
        </div>

        {error && (
          <span className="text-sm text-red-600">
            {t("forms.field.selected")}
          </span>
        )}
      </div>
    </Fragment>
  );
};
